import React, { useEffect, useState, useRef } from 'react'; //import React Component
import { cloudStore } from '../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';

export function Allcoupon() {
    let userID = localStorage.getItem("currentLoginUserID");

    const [couponCollection, setcouponCollection] = useState([])
    useEffect(() => {
        if (userID !== null) {
            getDocs(query(collection(cloudStore, "userCoupon"), where("Coupon_Information.ownerID", "==", userID)))
                .then((querySnapshot) => {
                    const data = querySnapshot.docs.map((doc) => doc.data());
                    setcouponCollection(data)
                })
        }
    }, []);

    const couponCollectionRef = useRef(null);
    useEffect(() => {
        if (couponCollection.length > 0) {
            couponCollection[0].Coupon_Information["金额"].sort((a, b) => a - b);
            const eachCollection = couponCollection[0].Coupon_Information["金额"].map((content, index) => {
                return (
                    <div className="each each_coupon" key={index}>
                        <div className='eachCoupon'>
                            <div className='couponTitle'>优惠券</div>
                            <div className='couponContent'>{content}$</div>
                        </div>
                    </div >
                )
            })
            couponCollectionRef.current = eachCollection;
        }
    })
    return (
        <div className='collection_content' style={{ marginTop: "50px" }}>
            <div className='h2bg'>
                <h2>您的优惠券</h2>
            </div>
            <div className="store">
                {couponCollectionRef.current}
            </div>
        </div>
    );
}